<template>
  <loading
    :opacity="0.85"
    background-color="#113d63"
    :active="isLoading"
    :can-cancel="canCancel"
    :lock-scroll="true"
  >
    <template slot="default">
      <div class="container no-select">
        <div class="text-center">
          <img
            src="@assets/images/logo_transparente_white.png"
            alt
            height="220"
            class="mb-1"
          />
          <br />
          <b-spinner variant="light" label="Spinning" />
          <br />
        </div>
        <p
          v-if="messageError"
          class="mt-2 text-danger text-center font-weight-bold"
        >
          {{ messageError ? messageError : '' }}
        </p>
        <p v-else-if="text" class="mt-2 text-white text-center">
          {{
            text && typeof text === 'string'
              ? text
              : text && typeof text !== 'string'
              ? messageFeedbackLoading
              : ''
          }}
        </p>
      </div>
    </template>
  </loading>
</template>

<script>
import Loading from 'vue-loading-overlay'

export default {
  components: { Loading },

  props: {
    // eslint-disable-next-line vue/require-prop-types
    text: {
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    canCancel: {
      type: Boolean,
      default: false,
    },
    messageError: {
      type: String,
      default: '',
    },

    welcome: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      messageFeedbackLoading: '',
    }
  },
  mounted() {
    if (typeof text !== 'string') {
      const randomMessages = [
        'Preparando sua obra para o sucesso...',
        'Gerenciando cada detalhe com cuidado...',
        'Otimizando os processos para a sua satisfação...',
        'Fazendo da sua obra uma obra de arte...',
        'Inovando e solucionando desafios...',
        'Acompanhando cada etapa do seu projeto...',
        'Unindo tecnologia e experiência para o seu projeto...',
        'Superando obstáculos e cumprindo prazos...',
        'Trabalhando com paixão e compromisso...',
        'Fazendo da sua obra um exemplo de excelência...',
        'Integrando qualidade, beleza e conforto em cada obra...',
        'Desenvolvendo projetos inteligentes e funcionais...',
        'Facilitando o gerenciamento de cada detalhe da sua obra...',
        'Construindo sonhos e realizando projetos...',
        'Fazendo da sua obra um motivo de orgulho e satisfação...',
        'Oferecendo soluções criativas e personalizadas para sua obra...',
        'Gerenciando a sua obra com eficácia e agilidade...',
        'Fazendo da sua obra uma referência de bom gosto e eficiência...',
        'Construindo com qualidade e respeito ao meio ambiente...',
        'Aplicando as mais eficazes estratégias e metodologias em cada obra...',
        'Gerenciando a sua obra com dedicação e comprometimento...',
        'Coordenando a sua obra com habilidade e experiência...',
        'Fazendo da sua obra um exemplo de sucesso e reconhecimento...',
        'Aprimorando cada aspecto da sua obra com criatividade e competência...',
        'Empregando melhor os recursos em cada obra...',
        'Proporcionando felicidade, orgulho e realização em cada obra...',
      ]

      setTimeout(() => {
        this.messageFeedbackLoading = this.text[0]
      }, 1)

      setTimeout(() => {
        // pega mensagem aleatória e atribui ao messageFeedbackLoading
        this.messageFeedbackLoading =
          randomMessages[Math.floor(Math.random() * randomMessages.length)]

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 8000)

      setTimeout(() => {
        this.messageFeedbackLoading = this.text[1]
          ? this.text[1]
          : (this.messageFeedbackLoading =
              randomMessages[Math.floor(Math.random() * randomMessages.length)])

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 16000)

      setTimeout(() => {
        // pega mensagem aleatória e atribui ao messageFeedbackLoading
        this.messageFeedbackLoading =
          randomMessages[Math.floor(Math.random() * randomMessages.length)]

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 24000)

      setTimeout(() => {
        this.messageFeedbackLoading =
          this.text[2] ||
          (this.messageFeedbackLoading =
            randomMessages[Math.floor(Math.random() * randomMessages.length)])

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 32000)

      setTimeout(() => {
        // pega mensagem aleatória e atribui ao messageFeedbackLoading
        this.messageFeedbackLoading =
          randomMessages[Math.floor(Math.random() * randomMessages.length)]

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 48000)

      setTimeout(() => {
        this.messageFeedbackLoading =
          this.text[3] ||
          (this.messageFeedbackLoading =
            randomMessages[Math.floor(Math.random() * randomMessages.length)])

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 56000)

      setTimeout(() => {
        // pega mensagem aleatória e atribui ao messageFeedbackLoading
        this.messageFeedbackLoading =
          randomMessages[Math.floor(Math.random() * randomMessages.length)]

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 64000)

      setTimeout(() => {
        this.messageFeedbackLoading =
          this.text[4] ||
          (this.messageFeedbackLoading =
            randomMessages[Math.floor(Math.random() * randomMessages.length)])

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 72000)

      setTimeout(() => {
        // pega mensagem aleatória e atribui ao messageFeedbackLoading
        this.messageFeedbackLoading =
          randomMessages[Math.floor(Math.random() * randomMessages.length)]

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 80000)

      setTimeout(() => {
        this.messageFeedbackLoading =
          this.text[5] ||
          (this.messageFeedbackLoading =
            randomMessages[Math.floor(Math.random() * randomMessages.length)])

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 88000)

      setTimeout(() => {
        // pega mensagem aleatória e atribui ao messageFeedbackLoading
        this.messageFeedbackLoading =
          randomMessages[Math.floor(Math.random() * randomMessages.length)]

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 96000)

      setTimeout(() => {
        // pega mensagem aleatória e atribui ao messageFeedbackLoading
        this.messageFeedbackLoading =
          randomMessages[Math.floor(Math.random() * randomMessages.length)]

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 104000)

      setTimeout(() => {
        // pega mensagem aleatória e atribui ao messageFeedbackLoading
        this.messageFeedbackLoading =
          randomMessages[Math.floor(Math.random() * randomMessages.length)]

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 112000)

      setTimeout(() => {
        // pega mensagem aleatória e atribui ao messageFeedbackLoading
        this.messageFeedbackLoading =
          randomMessages[Math.floor(Math.random() * randomMessages.length)]

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 120000)

      setTimeout(() => {
        // pega mensagem aleatória e atribui ao messageFeedbackLoading
        this.messageFeedbackLoading =
          randomMessages[Math.floor(Math.random() * randomMessages.length)]

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 128000)

      setTimeout(() => {
        // pega mensagem aleatória e atribui ao messageFeedbackLoading
        this.messageFeedbackLoading =
          randomMessages[Math.floor(Math.random() * randomMessages.length)]

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 136000)

      setTimeout(() => {
        // pega mensagem aleatória e atribui ao messageFeedbackLoading
        this.messageFeedbackLoading =
          randomMessages[Math.floor(Math.random() * randomMessages.length)]

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 144000)

      setTimeout(() => {
        // pega mensagem aleatória e atribui ao messageFeedbackLoading
        this.messageFeedbackLoading =
          randomMessages[Math.floor(Math.random() * randomMessages.length)]

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 152000)

      setTimeout(() => {
        // pega mensagem aleatória e atribui ao messageFeedbackLoading
        this.messageFeedbackLoading =
          randomMessages[Math.floor(Math.random() * randomMessages.length)]

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 160000)

      setTimeout(() => {
        // pega mensagem aleatória e atribui ao messageFeedbackLoading
        this.messageFeedbackLoading =
          randomMessages[Math.floor(Math.random() * randomMessages.length)]

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 168000)

      setTimeout(() => {
        // pega mensagem aleatória e atribui ao messageFeedbackLoading
        this.messageFeedbackLoading =
          randomMessages[Math.floor(Math.random() * randomMessages.length)]

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 176000)

      setTimeout(() => {
        // pega mensagem aleatória e atribui ao messageFeedbackLoading
        this.messageFeedbackLoading =
          randomMessages[Math.floor(Math.random() * randomMessages.length)]

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 184000)

      setTimeout(() => {
        // pega mensagem aleatória e atribui ao messageFeedbackLoading
        this.messageFeedbackLoading =
          randomMessages[Math.floor(Math.random() * randomMessages.length)]

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 192000)

      // 21
      setTimeout(() => {
        // pega mensagem aleatória e atribui ao messageFeedbackLoading
        this.messageFeedbackLoading =
          randomMessages[Math.floor(Math.random() * randomMessages.length)]

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 200000)

      setTimeout(() => {
        // pega mensagem aleatória e atribui ao messageFeedbackLoading
        this.messageFeedbackLoading =
          randomMessages[Math.floor(Math.random() * randomMessages.length)]

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 208000)

      setTimeout(() => {
        // pega mensagem aleatória e atribui ao messageFeedbackLoading
        this.messageFeedbackLoading =
          randomMessages[Math.floor(Math.random() * randomMessages.length)]

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 216000)

      setTimeout(() => {
        // pega mensagem aleatória e atribui ao messageFeedbackLoading
        this.messageFeedbackLoading =
          randomMessages[Math.floor(Math.random() * randomMessages.length)]

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 224000)

      setTimeout(() => {
        // pega mensagem aleatória e atribui ao messageFeedbackLoading
        this.messageFeedbackLoading =
          randomMessages[Math.floor(Math.random() * randomMessages.length)]

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 232000)

      setTimeout(() => {
        // pega mensagem aleatória e atribui ao messageFeedbackLoading
        this.messageFeedbackLoading =
          randomMessages[Math.floor(Math.random() * randomMessages.length)]

        // remove a mensagem do array
        randomMessages.splice(
          randomMessages.indexOf(this.messageFeedbackLoading),
          1
        )
      }, 240000)
    }
  },
}
</script>

<style>
.no-select {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  pointer-events: none;
}
</style>